import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import UserService from "../../../services/user.service";
import Instagram from "../contact/instagram";

type Props = {
  t: any;
};

type State = {
  content: string;
  isModalOpen: boolean;
};

class WhatAppOffers extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      content: "",
      isModalOpen: false
    };
  }

  componentDidMount() {
    UserService.getPublicContent().then(
      (response) => {
        this.setState({
          content: response.data
        });
      },
      (error: { response?: { data: string }; message?: string }) => {
        this.setState({
          content:
            (error.response && error.response.data) ||
            error.message ||
            "An error occurred"
        });
      }
    );
  }

  render() {
    const { t } = this.props;

    const lineStyleBold: React.CSSProperties = {
      marginTop: "1.4rem",
      lineHeight: "1.6",
      fontSize: "1.1rem",
      color: "var(--color07)",
      maxWidth: "800px",
      textAlign: "center",
      letterSpacing: "1.05em",
    };

    const lineStyle: React.CSSProperties = {
      lineHeight: "1.6",
      fontSize: "1rem",
      color: "var(--color07)",
      maxWidth: "800px",
      textAlign: "center",
    };

    const buttonWrapperStyle: React.CSSProperties = {
      textAlign: "center",
      marginTop: "1.5rem",
    };

    return (
      <div className="card-container center">
        <div>
          <p style={lineStyleBold}>{t("home_page.user_01")}</p>
          <p style={lineStyle}>{t("home_page.user_02")}</p>
          <p style={lineStyle}>{t("home_page.user_03")}</p>
          <p style={lineStyle}>{t("home_page.user_04")}</p>
          <p style={lineStyle}>{t("home_page.user_05")}</p>

          <p style={lineStyleBold}>{t("home_page.trainer_01")}</p>
          <p style={lineStyle}>{t("home_page.trainer_02")}</p>
          <p style={lineStyle}>{t("home_page.trainer_03")}</p>
          <p style={lineStyle}>{t("home_page.trainer_04")}</p>

          <div style={buttonWrapperStyle}>
            <img
              src="/images/envelope_transparent.png"
              alt="Send message"
              style={{
                width: "3rem",
                height: "2rem",
                margin: "0 0.5rem 1rem 0",
                verticalAlign: "middle",
              }}
            />
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              style={{
                display: "inline-block",
                padding: "0.5rem 1rem",
                color: "white",
                borderRadius: "1rem",
                textDecoration: "none",
                fontWeight: "bold",
                backgroundColor: "transparent",
                transition: "background-color 0.3s ease",
                verticalAlign: "middle",
                marginBottom: "1rem",
              }}
              className="button"
              onMouseOver={(e) =>
                (e.currentTarget.style.backgroundColor = "#C13584")
              }
              onMouseOut={(e) =>
                (e.currentTarget.style.backgroundColor = "transparent")
              }
            >
              {t("buttons.send_message")}
            </a>
            <Instagram username="mateuszsmykal" />
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("global")(WhatAppOffers);
